// Set coordinates for our locations in Steetview
export const locationCoordinates = [
    [{ lat: 36.385822,  lng: 127.496827 }, {location: 'South Korea'}], 
    [{ lat: -22.9520502,  lng: -43.2113599 }, {location: 'Brazil'}], 
    [{ lat: 64.164175,  lng: -22.021422 }, {location: 'Iceland'}], 
    [{ lat: 13.74732370422358, lng: 100.49613033270501 }, {location: 'Thailand'}],  
    [{ lat: -37.811844398680314, lng: 144.96759668243945 }, {location: 'Australia'}],  
    [{ lat: 6.252079237587264, lng: -75.56833320924022 }, {location: 'Columbia'}],  
    [{ lat: 40.81032909670101, lng: -73.94745172480059 }, {location: 'USA'}],  
    [{ lat: 43.64268266021944, lng: -79.38257214670162 }, {location: 'Canada'}], 
    [{ lat: 38.69732988290357, lng: -9.204558132916544 }, {location: 'Portugal'}], 
    [{ lat: 14.59191039633924, lng: 120.97329701809102 }, {location: 'Philippines'}], 
    [{ lat: 37.97343569109015, lng: 23.733796666485915 }, {location: 'Greece'}],
    [{ lat: 43.76052289282223, lng: 11.24199102419296 }, {location: 'Italy'}],
    [{ lat: 41.404481012777566, lng: 2.176676488240237 }, {location: 'Spain'}],
    [{ lat: 52.372878816222396, lng: 4.9124644387707725 }, {location: 'Netherlands'}],
    [{ lat: 51.49749474185877, lng: -0.13558904642666572 }, {location: 'England'}],
    [{ lat: 19.424745695980704, lng: -99.18494693513716 }, {location: 'Mexico'}],
    [{ lat: 22.284666251565774, lng: 114.173810488489 }, {location: 'Hong Kong'}],
    [{ lat: 34.990320880962635, lng: 135.76626977212106 }, {location: 'Japan'}],
    [{ lat: -33.853115340616796, lng: 151.24589801725926 }, {location: 'Australia'}],
    [{ lat: -41.290643779749175, lng: 174.78591007159525 }, {location: 'New Zealand'}],
    [{ lat: -13.192125313733207, lng: -72.53656374213867 }, {location: 'Peru'}],
    [{ lat: 48.859308904098754, lng: 2.305188678188841 }, {location: 'France'}],
    [{ lat: 25.195660959887228, lng: 55.27315819300908 }, {location: 'Dubai'}],
    [{ lat: 1.2870906416629924, lng: 103.85439015831402 }, {location: 'Singapore'}],
    [{ lat: 20.685062009422968, lng: -88.56822026492381 }, {location: 'Mexico'}],
    [{ lat: 55.753973153634256, lng: 37.623226336944946 }, {location: 'Russia'}],
    [{ lat: 47.50217785148032, lng: 19.042383259935452 }, {location: 'Hungary'}],
    [{ lat: 47.94816676465809, lng: 106.95233390604905 }, {location: 'Mongolia'}],
  ];

  // Landmarks game mode
  export const landmarkCoordinates = [
    [{ lat: 37.83239660549644, lng: -122.49105833863116}, {location: 'Golden Gate Bridge, San Franciso, USA'}],
    [{ lat: 29.9756934,  lng: 31.1385296 }, {location: 'Great Pyramid at Giza, Luxor, Egypt'}],
    [{ lat: 48.8583611,  lng: 2.294443 }, {location: 'Eiffel Tower, Paris, France'}], 
    [{ lat: -3.0673889,  lng: 37.355583333333335 }, {location: 'Stella Point, Kilimanjaro, Tanzania'}], 
    [{ lat: -13.1628889,  lng: -72.54502777777778 }, {location: 'Machu Picchu, Peru'}], 
    [{ lat: 51.17886047076641,  lng: -1.8264145420701259 }, {location: 'Stonehenge, West Amesbury, England'}], 
    [{ lat: -44.66929752723259,  lng: 167.92783364779305 }, {location: 'Milford Sound, New Zealand'}],
    [{ lat: -33.85050228413567,  lng: 151.20383905381186 }, {location: 'Blues Point Reserve, Sydney, Australia'}],
    [{ lat: 7.828398400925314,  lng: 98.31182376517008 }, {location: 'The Big Buddha, Phuket, Thailand'}],
    [{ lat: 21.422633571593227,  lng: 39.826229590088374 }, {location: 'Masjid al-Haram, Mecca, Saudi Arabia'}],
    [{ lat: 41.889828687164716,  lng: 12.49386494391612 }, {location: 'The Colosseum, Rome, Italy'}],
    [{ lat: -20.137815054149687,  lng: -67.80203013232065 }, {location: 'Uyuni Salt Flat, Bolivia'}],
    [{ lat: 27.1731841514737, lng: 25.857630018919178 }, {location: 'Victoria Falls, Zambia'}],  
    [{ lat: -25.366850, lng: 131.065148}, {location: 'Uluru, Alice Springs, Australia'}],
    [{ lat: 52.516418, lng: 13.379506}, {location: 'Brandenburg Gate, Berlin, Germany'}],
    [{ lat: 25.195923, lng: 55.273326}, {location: 'Burj Al Arab, Dubai'}],
    [{ lat: 43.643037, lng: -79.388195}, {location: 'CN Tower, Old Toronto, Canada'}],
    [{ lat: 55.752199, lng: 37.623370}, {location: 'Red Square, Moscow, Russia'}],
    [{ lat: 41.00672993461, lng: 28.977926971412067}, {location: 'Sultan Ahmet Vakti, Istanbul, Turkey'}],
    [{ lat: 38.624462505957446, lng: -90.18445319004995}, {location: 'Grand Staircase, St Louis, USA'}],
    [{ lat: 30.329230676750644, lng: 35.442401570327156}, {location: 'Petra, Jordan'}],
    [{ lat: 40.689247, lng: -74.044502}, {location: 'Statue of Liberty, New York, USA'}]
  ];
  //had to meet following conditions
  // - need to appear on the api map
  // - need to be able to move around the street map
  // - easy enough to get clues to figure out where you are